import { action, computed, makeObservable, observable } from "mobx";

export class VariantExternalDataStore {
  @observable id;
  @observable variantId = null;
  @observable currentPrice = null;
  @observable originalPrice = null;
  @observable url = '';
  @observable retailerId = null;
  @observable inStock = true;
  @observable detectedOutOfStock = null;
  @observable isTouched = false;
  @observable fetchFailed = false;
  @observable description = null;
  @observable rating = null;
  @observable numberOfVoters = null;
  @observable userReviews = null;
  @observable similarItems = null;

  constructor(data) {
    makeObservable(this);
    if (data) {
      this.id = data.id;
      this.variantId = data.variantId;
      this.url = data.url;
      this.retailerId = data.retailerId;
      this.setData(data);
    }
  }

  @computed get haveScrapedData() {
    return this.currentPrice || this.originalPrice ||
      this.inStock !== null || this.detectedOutOfStock;
  }

  @action.bound setCurrentPrice = (currentPrice) => this.currentPrice = currentPrice;
  @action.bound setOriginalPrice = (origPrice) => this.originalPrice = origPrice;
  @action.bound setInStock = (inStock) => this.inStock = inStock;

  @action.bound setUrl = (url, isManual) => {
    this.url = url;
    if (!isManual) {
      this.touched();
    }
  }

  @action.bound setRetailerId = (id, isManual) => {
    this.retailerId = id;
    if (!isManual) {
      this.touched();
    }
  }

  @action.bound setIsTouched = (isTouched) => this.isTouched = isTouched;

  @action.bound setFetchFailed = (failed) => this.fetchFailed = failed;

  @action.bound touched = () => {
    this.setIsTouched(true);
    this.setData({ inStock: null, currentPrice: null, detectedOutOfStock: null, originalPrice: null });
  }

  @action.bound setData = ({ currentPrice, originalPrice, inStock, detectedOutOfStock, description, rating, numberOfVoters, similarItems, userReviews }) => {
    this.currentPrice = currentPrice;
    this.originalPrice = originalPrice;
    this.inStock = inStock;
    this.detectedOutOfStock = detectedOutOfStock;
    this.description = description;
    this.rating = rating;
    this.numberOfVoters = numberOfVoters;
    this.userReviews = userReviews;
    this.similarItems = similarItems;
  }
}
